import React, { Component } from 'react';
import './newHeader.scss'
import { /*Tooltip,*/ Modal, Button, Input, Select, message, Checkbox, Tree, Spin  } from 'antd';
import { PlusOutlined, CloseOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import {store} from 'Store/store.index';
import { inject, observer } from 'mobx-react';
import { createShare, updateShare, resetShareUrl, cancelShare, /*docCoordinationShareUserList, addCollaborator,*/ batchAddCollaborator, updateCollaborator, batchUpdateCollaborator, removeCollaborator, externalDepartments, externalUsers } from '@/api/fwApi/sharecollaboration';
const { Option } = Select
import intl from 'react-intl-universal';
import moment from 'moment';
import { localeToUTC } from 'Utils/date'
import { isPhantomOnline } from '@/utils/utils'
import { CREATE_A_LINK, START_COMMENTING } from 'Components/viewer/ui/constants/event.constants.share';
import { ADD_DEADLINE_SUCCESS, ADD_DEADLINE_FAILED, CREATE_SHARED_LINK_SUCCESS, CREATE_SHARED_LINK_FAILED } from 'Components/viewer/ui/constants/user.more.constants';
import { collaborationMqttService } from 'Store/services/index'
import { fileController } from '@/components/viewer/Controllers/index';
// import ShareBtn from "./share"

let noHideOrShow = false
@inject('userNewStore', 'common', 'shareStore')
@observer
class shareCollaborationbtn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userBgColorList: ['#ba91ff','#68AFFF','#EF80DB','#FFA800','#75D060','#48D3D5','#E99570','#758395','#9DB4E2'],
      docId: "", // ! 上传文档的Id
      fileName: "",
      isShowDialog: false,
      realNameDialog: false,
      sharePageDialog: false,
      createdShareDialog: false,
      realNameSuccessDialog: false,
      phoneNumber: "", // 手机号
      errText: "", // 错误提示
      getCode: false,
      getKeyText: "获取验证码",
      code: "",
      setBind: false,
      activeDays: 7,
      checkRadioValue: "publicShow",
      checkActionUser: false,
      showCompanyUserList: false,
      shareUserList: [],
      treeData: [],
      isCreate: false,
      hasPrompt: false,
      prompt: '',
      dateTime: '',
      shareLink: "",
      checkUserList: [],
      showSpin: false
    };
  }
  componentDidMount() {
    // 进入后立即去获取公司信息。
    this.getCompany()
  }
  getDocsInfo = () => {
    // 获取云文档token
    store.common.setIsShowMeeting(true) 
    store.docsStore.getToken().then(res => {
      // !获取token = res.data.token
      if(res.code === 0) {
        // 获取云文档更目录
        store.docsStore.getRootFolder().then(resFolder => {
          // !获取根目录id: folderId = res.data.folderId
          if(resFolder.code === 0){
            if(store.saveFileNewStore.isSaveSuccess) {
              store.appStore.doUpdateDocModified(false, true)
              store.saveFileNewStore.setIsSaveSuccess(false)
            }
            let docsFolderId = resFolder.data.folderId
            this.saveCurrentFile(docsFolderId)
          }
        }).catch(() => {
          store.common.setIsShowMeeting(false) 
        })
      }
    }).catch(() => {
      store.common.setIsShowMeeting(false) 
    })
  }
  saveCurrentFile = async (folderId) => {
    const pdfDoc = await window.pdfui.getCurrentPDFDoc();
    let fileName = pdfDoc.info.fileName
    store.docsStore.fileToBlob(fileName, folderId, false).then(res => {
      // res.code = 40003
      if (res.code === 0) {
        // !保存文件id
        store.common.setIsShowMeeting(false) 
        let data = res.data
        store.shareStore.setShareDocId(res.data.docId)
        this.setState({
          fileName: data.fileName,
          createdShareDialog: true
        })
      } else if (res.code === 40002) {
        //40002 文件名重名 添加时间戳
        let time = store.docsStore.formatCompleteTime(new Date());
        let fileNamePrefix = fileName.substring(
          0,
          fileName.lastIndexOf(".")
        );
        fileName = `${fileNamePrefix}_${time}.pdf`
        store.docsStore.fileToBlob(fileName, folderId)
      } else if (res.code === 40003) {
        // 1004 空间不足
        store.common.setIsShowMeeting(false) 
        store.docsStore.lackOfSpace();
      } else {
        store.common.setIsShowMeeting(false) 
      }
      store.common.setIsShowMeeting(false) 
    }).catch(() => {
      store.common.setIsShowMeeting(false) 
    })
  }
  // 点击分享
  shareClick = () => {
    // 判断是否可点击
    // 判断userId
    if(store.shareStore.shareDisabled || !store.userNewStore.userData.userId) {
      return
    }
    // 重新判断是否会员, res为identity
    store.userNewStore.checkVip().then(() => {
      if(store.viewer.hasOpenFile) {
        // 判断是否实名认证：是=>下一步；否=>弹出实名窗口
          store.userNewStore.isRealName().then(real =>{ //isRealName的接口需要jsonp
            if(real.ret === 1019 || real.ret === 1004) { //! 已实名
              if (store.shareStore.isShare) { // 该文件是否已经上传云文档
                // ! 已上传， 打开分享详情弹窗
                this.setState({
                  sharePageDialog: true
                })
              } else {
                // 已经上传文件
                if (store.shareStore.shareDocId) {
                  this.setState({
                    createdShareDialog: true
                  })
                } else {
                  this.getDocsInfo()
                }
            }
            } else { //! 未实名
              // 弹出实名窗口
              this.setState({
                realNameDialog: true
              })
            }
          }).catch(err => {
            console.log(err)
          })
        // }
      } else {
        this.setState( {isShowNoPdfModal: true})
        return
      }
    })
  }
  // 实名 —— 手机号
  changeTel = (e) => {
    this.setState({
      phoneNumber: e.target.value
    })
  }
  // 实名 —— 验证码
  changeCode = (e) => {
    this.setState({
      code: e.target.value
    })
  }
  // 实名 —— 获取验证码
  getKey = () => {
    if(this.state.getCode) {
      return
    }
    let tel = this.state.phoneNumber
    let mobile = /^1[3456789]\d{9}$/;
    if (!tel) {
      this.setState({
        errText: "请填写手机号码"
      })
      return
    } else if (!/^\d{11}$/.test(tel) || !mobile.test(tel)) {
      this.setState({
        errText: "请填写正确的手机号码"
      })
      return
    }
    store.userNewStore.isRealName(tel).then(res => {
      if(res.ret === 0) {
        this.setState({
          getCode: true,
          errText: ""
        })
        this.countDown()
      } else {
        this.setState({
          getCode: true
        })
        this.countDown()
        this.setState({
          errText: res.msg
        })
        return
      }
      
    })
  }
  // 实名 —— 校验手机号
  setBindTel = () => {
    if(this.state.setBind) {
      return
    }
    let code = this.state.code
    let tel = this.state.phoneNumber
    let mobile = /^1[3456789]\d{9}$/;
    if (tel === "") {
      this.setState({
        errText: "请填写手机号码"
      })
      return
    } else if (!/^\d{11}$/.test(tel) || !mobile.test(tel)) {
      this.setState({
        errText: "请填写正确的手机号码"
      })
      return
    }
    if (code === "") {
      this.setState({
        errText: "请填写验证码"
      })
      return
    }
    this.setState({
      setBind: true
    })
    store.userNewStore.setBindTel(tel, code).then(res => {
      if(res.ret === 0) {
        this.setState({
          code: "",
          phoneNumber: "",
          realNameDialog: false,
          realNameSuccessDialog: true,
          setBind: false,
          errText: ""
        })
        store.userNewStore.setRealName(true)
        setTimeout(() => {
          this.setState({
            realNameSuccessDialog: false
          })
        }, 2000)
      } else {
        this.setState({
          errText: res.msg,
          setBind: false
        })
      }
    }).catch(err => {
      this.setState({
        errText: err.msg || "",
        setBind: false
      })
    })
  }
  // 实名 —— 倒计时
  countDown() {
    let num = 60
    let countDown = setInterval(() => {
      num--;
      if(num == 0) {
        this.setState({
          getCode: false,
          getKeyText: "获取验证码"
        })
        clearInterval(countDown)
        return
      }
      this.setState({
        getKeyText: `重试(${num})`
      })
    }, 1000)
  }
  
  /*
   *  云编辑协同功能修改 methods
   */
  checkRadio = (e) => {
    this.setState({
      checkRadioValue: e
    })
  }
  // 0、 点击分享按钮
  shareCollaborationClick = async () => {
// 判断是否可点击
    // 判断userId
    if(store.shareStore.shareDisabled || !store.userNewStore.userData.userId) {
      return
    }
    const checkAnnotFormPermission = await fileController.checkAnnotFormPermission()
    if (checkAnnotFormPermission === 0) {
      store.appStore.setGlobalMessage({type: 'error', content: intl.get("collaboration.Dlg.noPermission")})
      return
    }
    const doc = await pdfui.getCurrentPDFDoc()
    if (doc && doc.isPortfolio()) {
      store.appStore.setGlobalMessage({type: 'error', content: intl.get("collaboration.Error.portfolioNotSupport")})
      return
    }

    const { shareUserType } = store.shareCollaborationStore
    if (!shareUserType) { // shareUserType为空，创建分享，否则为打开分享
      store.userNewStore.checkVip().then(() => {
        if(store.viewer.hasOpenFile) {
          // 判断是否实名认证：是=>下一步；否=>弹出实名窗口
          // 先跳过验证实名
          if (store.shareStore.isShare) { // 该文件是否已经发起分享
            // ! 已上传， 打开分享详情弹窗
            this.setState({
              sharePageDialog: true
            })
          } else {
            // 未分享直接显示
            this.setState({
              createdShareDialog: true
            })
          }
            // store.userNewStore.isRealName().then(real =>{ //isRealName的接口需要jsonp
            //   if(real.ret === 1019 || real.ret === 1004) { //! 已实名
            //     if (store.shareStore.isShare) { // 该文件是否已经发起分享
            //       // ! 已上传， 打开分享详情弹窗
            //       this.setState({
            //         sharePageDialog: true
            //       })
            //     } else {
            //       // 未分享直接显示
            //       this.setState({
            //         createdShareDialog: true
            //       })
            //     }
            //   } else { //! 未实名
            //     // 弹出实名窗口
            //     this.setState({
            //       realNameDialog: true
            //     })
            //   }
            // }).catch(err => {
            //   console.log(err)
            // })
        } else {
          this.setState( {isShowNoPdfModal: true})
          return
        }
      })
    } else if (shareUserType === "createShareUser") {
      let infoResult = await store.shareCollaborationStore.getDocShare()
      this.getDocCoordinationShareUserList()
      if(infoResult && infoResult.code === 0) {
        infoResult.data.shareValueType = infoResult.data.aclScope==1 ? "appointorShare" : (infoResult.data.acl==0 ? "publicShow": "publicAnnot")
        infoResult.data.isEncrypted = !!infoResult.data.isEncrypted ? 1 : 0
        this.setShareOption(infoResult.data);
        this.setState({
          sharePageDialog: true
        })
      }
    } else if (shareUserType === "joinShareUser") {
      let info = store.shareCollaborationStore.shareInfo
      info.shareValueType = info.aclScope==1 ? "appointorShare" : (info.acl==0 ? "publicShow": "publicAnnot")
      this.setShareOption(info);
      this.setState({
        sharePageDialog: true
      })
    }
  }
  // 1、创建分享 —— 发起协同的链接创建
  createLink = () => {
    if(!window.__online__ && isPhantomOnline()){
      store.appStore.doNotifyErrors('offline');
      return;
    }
    store.userStore.doSendGAEvent({eventKey: CREATE_A_LINK, label:'share_files_dialog'});
    this.setState({
      showSpin: true
    }) 
    this.setState({ isCreate: true, hasPrompt: false, prompt: '' })
    const { dateTime } = this.state
    // const dateTime =  new Date(new Date().getTime() + (7 * 24 * 60 * 60 * 1000))
    const sendData = {
      deadline: dateTime ? moment(localeToUTC(moment(dateTime).format('YYYY-MM-DD HH:mm:ss'))).format('YYYY-MM-DD HH:mm:ss:000') : '',
      prohibitComment: 0, // 由前端处理禁止评论操作
      // this.state.checkRadioValue==="publicShow" ? 1 : 0
    }
    // 创建链接
    store.collaborationStore.createShareFileLink(sendData).then((url) => {
      store.collaborationStore.updateIsCreatingShareReview(false)
      this.setState({
        shareLink: url, // 缓存下shareLink，这是旧的协同链接
        isCreate: false
      })
      store.userStore.doSendGAEventByUserEvent(CREATE_SHARED_LINK_SUCCESS, null, null);
      if(!!dateTime){
        store.userStore.doSendGAEventByUserEvent(ADD_DEADLINE_SUCCESS, null, null);
      }
      this.startCommenting()
    }, error => {
      this.setState({
        showSpin: false
      }) 
      const { reviewSessionID } = store.collaborationStore
      if(reviewSessionID) {
        const sendData = {
          reviewSessionID,
          delFlag: 1
        }
        // 协作创建过程出错时，删除该协作
        store.collaborationStore.putShareReview(sendData)
      }
      store.collaborationStore.updateIsCreatingShareReview(false)
      store.userStore.doSendGAEventByUserEvent(CREATE_SHARED_LINK_FAILED, null, null);
      if(!!dateTime){
        store.userStore.doSendGAEventByUserEvent(ADD_DEADLINE_FAILED, null, null);
      }
      if(error.ret && error.ret === 110002){
        const errorMsg = intl.get('collaboration.Error.hasShared');
        store.collaborationStore.postErrorMsg({type:'error',errorInfo:errorMsg})
      }else if(error.ret && error.ret === 110016){
        const errorMsg = intl.get('collaboration.Error.noPermission');
        store.collaborationStore.postErrorMsg({type:'error',errorInfo:errorMsg})
      }else if(error.type == 'noAlert'){
      }else{
        const errorMsg = intl.get('UnKnownError') ;
        store.collaborationStore.postErrorMsg({type:'error',errorInfo:errorMsg})
      }
      if(error.source === 'fileSizeOver') {
        message.warning('文件大小不能超过30MB，请选择其他文件后重试。')
        this.setState({
          createdShareDialog: false
        })
        // 文件大小超过30M，不允许分享
        // setTimeout(() => {
        //   this.setState({
        //     isCreate: false,
        //     hasPrompt: true,
        //     prompt: intl.get('collaboration.Dlg.FileExceededSize', { fileSize: 30 }),
        //   })
        // }, 500);
      } else {
        this.setState({
          createdShareDialog: false
        })
      }
      store.collaborationStore.restoreAnnotsForCache()
    })
  }
  startCommenting = async () => {
    store.userStore.doSendGAEvent({eventKey: START_COMMENTING, label:'share_files_dialog'});
    if (!isPhantomOnline()) {
      store.collaborationStore.openSharedFileForPhantom()
      return 
    }
    this.createdAndShare()
    store.collaborationStore.startComment()
  }
  createdAndShare = () => {
    // 创建并分享,这里需要先调用协同的接口，然后再执行以下步骤
    // 调用新的接口
    let params = {}
    params.acl = this.state.checkRadioValue === 'publicShow' ? '0' : (this.state.checkRadioValue === 'appointorShare' ? '1' : '1') // 控制权限(-1:无限制,0:可查看,1:可标注)
    params.aclScope = this.state.checkRadioValue === 'appointorShare' ? '1' : '0' //范围(0:全部人员,1:部分人员)
    params.isEncrypted = false
    params.docId = store.shareStore.shareDocId
    params.activeDays = 7
    params.owner = store.userNewStore.userData.nickname
    params.avatar = store.userNewStore.userData.figure
    // 这里加一层逻辑，首先调用现有协同的创建链接功能。。
    // 完成后执行协同操作
    // 最后调用新增的创建分享文件功能
    createShare({params}).then(res => {
      if(res) {
        if(res.code === 0) {
          res.data.shareValueType = this.state.checkRadioValue
          res.data.isEncrypted = !!res.data.isEncrypted ? 1 : 0
          store.shareCollaborationStore.setShareUserType("createShareUser")
          this.setShareOption(res.data);
          this.getDocCoordinationShareUserList() // 获取用户信息
          store.shareStore.setIsShare(true)
          setTimeout(() => {
            this.setState({
              showSpin: false,
              createdShareDialog: false,
              sharePageDialog: true
            })
          }, 300)
        }
      } else {
        this.setState({
          showSpin: false,
          createdShareDialog: true,
          sharePageDialog: false
        })
      }
    })
  }
  // 2、存储分享信息，添加分享Id
  setShareOption = (data) => {
    if(data.shareUrl.includes("/cloudShare/") && !data.shareUrl.includes("/#/cloudShare")) {
      let urlArr = data.shareUrl.split("/cloudShare/")
      data.shareUrl = `${urlArr[0]}/#/cloudShare/${urlArr[1]}`
    }
    data.shareValueType = data.aclScope==1 ? "appointorShare" : (data.acl==0 ? "publicShow": "publicAnnot")
    data.isEncrypted = data.drawCode ? 1 : 0
    store.shareStore.setShareDocsInfo(data)
    store.shareCollaborationStore.setShareInfo(data)
  }
  // 3、修改分享信息
  resetShareUrlFunc = () => {
    let info = store.shareCollaborationStore.shareInfo || store.shareStore.shareDocsInfo 
    resetShareUrl({params: {shareId: info.id}}).then(res => {
      if(res.code===0) {
        // 在请求接口前需要弹窗
        info = {...info, ...res.data}
        this.setShareOption(info)
        this.setState({
          showResetLinkModel: false
        })
        // store.shareStore.setShareDocsInfo(info)
      }
    })
  }
  deleteShareUrlFunc = () => {
    let info = store.shareCollaborationStore.shareInfo || store.shareStore.shareDocsInfo
    cancelShare({params: {shareId: info.id}}).then(res => {
      if(res.code===0) {
        // 執行原逻辑取消协作的操作
        // 增加取消分享后跳转到了分享页面一，这时候需要终止协同。
        store.shareStore.setIsShare(false)
        store.shareStore.shareDocsInfo = {}
        collaborationMqttService.publish("cancelShareUser") // 触发mqtt通信
        this.setState({
          showDeleteShareModel: false,
          sharePageDialog: false,
          createdShareDialog: true
        })
      }
    })
  }
  changeActiveDay = (e, key) => {
    let info = store.shareCollaborationStore.shareInfo || store.shareStore.shareDocsInfo
    if(key === "shareValueType" && e === "resetLink") { // 重置鏈接
      this.setState({
        showResetLinkModel: true
      })
    }
    if(key === "shareValueType" && e === "deleteShare") { // 取消分享
      this.getFileName()
      this.setState({
        showDeleteShareModel: true
      })
      // cancelShare({params: {shareId: info.id}}).then(res => {
      //   if(res.code===0) {
      //     // 執行原逻辑取消协作的操作
      //     // 增加取消分享后跳转到了分享页面一，这时候需要终止协同。
      //     store.shareStore.setIsShare(false)
      //     store.shareStore.shareDocsInfo = {}
      //     collaborationMqttService.publish("cancelShareUser") // 触发mqtt通信
      //     this.setState({
      //       sharePageDialog: false,
      //       createdShareDialog: true
      //     })
      //   }
      // })
      return
    }
    // let oldAclScope = info.aclScope
    info[key] = e
    if(key === "shareValueType") {
      switch (e){
        case "publicShow":
          info.acl = "0";
          info.aclScope = "0";
          break
        case "publicAnnot":
          info.acl = "1";
          info.aclScope = "0";
          break
        case "appointorShare":
          info.acl = "1";
          info.aclScope = "1";
          break
      }
    }
    // 这里处理修改权限逻辑
    updateShare({params:{...info}}).then(res => {
      this.setShareOption(res.data)
      // 更新信息通知
      collaborationMqttService.publish("changeToAppointorShare", {userList: this.shareUserList})
      // if(info.aclScope !== oldAclScope) { 
      //   if(info.aclScope === "1") { // 当修改权限为特定人员可访问，触发mqtt清除非特定人员
      //     collaborationMqttService.publish("changeToAppointorShare", {userList: this.shareUserList})
      //   }
      //   //  else {
      //   //   if(info.acl !== oldAcl) {
      //   //     collaborationMqttService.publish("changeAnyShareType", {acl: info.acl}) // 修改为所有人可访问，当前所有人权限变更，查看或可评论
      //   //   }
      //   // }
      // } else {
      //   // if(info.acl !== oldAcl) {
      //   //   collaborationMqttService.publish("changeAnyShareType", {acl: info.acl}) // 修改为所有人可访问，当前所有人权限变更，查看或可评论
      //   // }
      // }
    })
  }
  // 4、获取当前分享的用户列表，在创建、添加用户、删除用户、修改用户信息后获取。
  getDocCoordinationShareUserList = async () => {
    let result = await store.shareCollaborationStore.getDocCoordinationShareUserList()
    if(result.code === 0) {
      store.shareCollaborationStore.setShareUserList(result.data)
      this.setState({shareUserList: result.data})
    }
  }
  // 5、获取用户公司人员信息
  getCompany = async () => {
    let departmentsInfo = await externalDepartments().catch(err => {console.log(err)})
    let usersInfo = await externalUsers().catch(err => {console.log(err)})
    let companyName = store.userNewStore.userData && store.userNewStore.userData.companyName
    let treeMain = {}
    // 公司信息树需要两个都成功
    if(departmentsInfo.ret === 0 && usersInfo.ret === 0) {
      let treeData = departmentsInfo.data.map(item => {
        return {
          key: item.id,
          title: item.name,
          children: item.children || []
        }
      })
      usersInfo.data && usersInfo.data.length>0 && usersInfo.data.forEach(item => {
        treeData.forEach(department => {
          if(item.departmentId === department.key) {
            department.children.push({
              ...item,
              key: item.id.toString(),
              title: item.nickName,
              disableCheckbox: store.userNewStore.userData.userId === item.ssoUserId
            })
          }
        })
      })
      if(companyName) {
        treeMain = {
          key: "main",
          title: companyName,
          children: treeData
        }
        this.setState({
          treeData: [treeMain],
          treeUserList: usersInfo.data
        })
      } else {
        this.setState({
          treeData,
          treeUserList: usersInfo.data
        })
      }
    }
  }
  // 添加协作者，这个需要作为公用方法处理，后续
  addCollaboratorUser = async (userItem, urlJoin) => {
    let result = await store.shareCollaborationStore.addCollaboratorUser(userItem, urlJoin)
    return new Promise(resolve => {
      if(result && result.code === 0) {
        collaborationMqttService.publish("addCollaboratorUser") // 触发mqtt通信
        this.getDocCoordinationShareUserList()
        resolve()
      }
    })
  }
  // 批量添加
  batchAddCollaboratorUser = (userList, urlJoin) => {
    const { shareDocsInfo } = store.shareStore
    let shareInfo = store.shareCollaborationStore.shareInfo || shareDocsInfo
    let config = {
      params: 
      {
        body:[]
      }
    }
    userList.forEach(item => {
      let param = {
        acl: -1,
        joinDesc: urlJoin ? "链接访问": "直接指定添加",
        nickName: item.nickName || item.nickname,
        shareId: shareInfo.shareId,
        userId: item.userId,
        avatar: item.figure
      }
      config.params.body.push(param)
    })
    batchAddCollaborator(config).then(res => {
      if(res.code === 0) {
        this.getDocCoordinationShareUserList()
      }
    })
  }
  // 修改权限
  updateCollaboratorUser = (userItem) => {
    const { shareDocsInfo } = store.shareStore
    let shareInfo = store.shareCollaborationStore.shareInfo || shareDocsInfo
    let params = {
      shareId: shareInfo.shareId,
      acl: userItem.acl,
      userId: userItem.userId
    }
    updateCollaborator({params}).then(res => {
      if(res.code === 0) {
        // 触发用户的权限修改
        collaborationMqttService.publish("changeShareUserAuth", {acl: params.acl, userId: params.userId})
        this.getDocCoordinationShareUserList()
      }
    })
  }
  // 批量修改权限
  batchUpdateCollaboratorUser = (userList) => {
    const { shareDocsInfo } = store.shareStore
    let shareInfo = store.shareCollaborationStore.shareInfo || shareDocsInfo
    let params = []
    userList.forEach(item => {
      let param = {
        acl: item.acl,
        userId: item.userId
      }
      params.push(param)
    })
    batchUpdateCollaborator({shareId: shareInfo.shareId, params}).then(res => {
      if(res.code === 0) {
        this.getDocCoordinationShareUserList()
      }
    })
  }
  // 删除人员
  removeCollaboratorUser = (id) => {
    const { shareDocsInfo } = store.shareStore
    let shareInfo = store.shareCollaborationStore.shareInfo || shareDocsInfo
    return new Promise((resolve, reject) => {
      removeCollaborator({params: {shareId: shareInfo.shareId, userId: id}}).then(res => {
        if(res.code === 0) {
          collaborationMqttService.publish("removeCollaboratorUser", {userId: id}) // 触发mqtt通信
          this.getDocCoordinationShareUserList()
          resolve(res.data)
        }
      }).catch(err => {
        reject(err)
      })
    })
    
  }
  // 6、 复制分享链接
  copyThis = () => {
    // collaborationMqttService.publish("newMqttType")
    // 复制文本到剪切板
    const shareDocsInfo = store.shareStore.shareDocsInfo
    let shareInfo = store.shareCollaborationStore.shareInfo || shareDocsInfo
    let copyThis = ""
    if(shareInfo.drawCode && shareInfo.drawCode!== "false" && shareInfo.drawCode!== "true") {
      copyThis = `【 链接：${shareInfo.shareUrl} 密码：${shareInfo.drawCode}】`
    } else {
      copyThis = `【 链接：${shareInfo.shareUrl} 】`
    }
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.setAttribute('value', copyThis);
    input.select();
    if (document.execCommand('copy')) {
        document.execCommand('copy');
        message.success('复制成功');
    }
    document.body.removeChild(input);
  }

  onCheckboxChange = (vals) => {
    this.setState({
      checkUserList: vals
    })
    
  }
  changeUser = (val, item) => {
    if(val === "delete") { // 删除用户
      this.removeCollaboratorUser(item.userId)
    } else {
      if(item.acl === val) {
        return
      }
      item.acl = val
      this.updateCollaboratorUser(item)
    }
  }
  changeCheckUser = (val, checkUser, userlist) => {
    userlist.forEach(item => {
      if(checkUser.includes(item.userId)) {
        item.acl = val
        this.updateCollaboratorUser(item)
      }
    })
  }
  showCompanyBtn = () => {
    if(this.state.showCompanyUserList) {
      return
    }
    noHideOrShow = true
    let idList = this.state.shareUserList.map(item => {return item.userId})
    let treeIdList = []
    this.state.treeData[0].children.forEach(items => {
      let thisId = items.children.filter(item => {
        return idList.includes(item.ssoUserId.toString())
      })
      treeIdList = [...treeIdList, ...thisId]
    })
    let list = treeIdList.map(item => {return item.key.toString()})
    this.setState({
      treeIdList: list,
      showCompanyUserList: true,
      // noHideOrShow: true
    })
    setTimeout(() => {
      noHideOrShow = false
      // this.setState({
      //   noHideOrShow: false
      // })
    }, 500)
  }
  onCheck = (checkedKeys, info) => {
    // 修改，check后直接添加、删除成员
    // 遍历info.checkedNodes ，选择含义ssoUserId的数据
    // 对比this.state.treeIdList，多了为添加，少了为删除，调用接口，显示loading，修改treeIdList
    let newCheckInfoList = []
    let newCheckIdList = []
    info.checkedNodes.forEach(item => {
      if(item.props && item.props.ssoUserId) {
        newCheckInfoList.push(item.props)
        newCheckIdList.push(item.props.id.toString())
      }
    })
    if(this.state.treeIdList.length > newCheckInfoList.length) { // 删除操作
      this.state.treeIdList.forEach(item => {
        if(!newCheckIdList.includes(item)) {
          this.state.treeData[0].children.forEach(items => {
            items.children.forEach(i => {
              if(i.id == item) {
                this.removeCollaboratorUser(i.ssoUserId).then(() => {
                  this.setState({
                    treeIdList: newCheckIdList
                  })
                })
              }
            })
          })
        }
      })
    }
    if(this.state.treeIdList.length < newCheckInfoList.length) { // 增加操作
      newCheckInfoList.forEach(item => {
        if(!this.state.treeIdList.includes(item.id.toString())) {
          this.addCollaboratorUser({
            nickname: item.nickName,
            userId: item.ssoUserId,
            figure: item.figure || ""
          }).then(() => {
            this.setState({
              treeIdList: newCheckIdList
            })
          })
        }
      })
    }
    // this.setState({
    //   treeCheckInfo: info
    // })
  }
  hideCompanyBtn = () => {
    if(noHideOrShow) {
      return
    }
    if(!this.state.showCompanyUserList) {
      return
    }
    let newCheckList = []
    let checkedNodes = this.state.treeCheckInfo && this.state.treeCheckInfo.checkedNodes || []
    checkedNodes.forEach(item => {
      if(item.props && item.props.ssoUserId && !item.props.disableCheckbox) {
        newCheckList.push(item.props)
      }
    })
    newCheckList.forEach(item => {
      if(this.state.treeIdList.includes(item.id.toString())) {
        return
      }
      this.addCollaboratorUser({
        nickname: item.nickName,
        userId: item.ssoUserId,
        figure: item.figure || ""
      })
    })
    this.setState({
      showCompanyUserList: false,
      showCompanySearchList: false,
      searchList: [],
      shareSearchUserValue: "",
    })
  }
  getInfo = () => {
    const shareDocsInfo = store.shareStore.shareDocsInfo
    let shareInfo = store.shareCollaborationStore.shareInfo || shareDocsInfo
    return shareInfo
  }
  shareSearchInput = (e) => {
    if(!this.state.showCompanyUserList) {
      this.showCompanyBtn()
    }
    let value = e.target.value
    this.setState({
      shareSearchUserValue: value
    })
    if(value) {
      // 没有搜索到人的时候值的时候noSearch: true
      let searchList = []
      this.state.treeUserList.length>0 && this.state.treeUserList.forEach(item => {
        if(item.nickName.includes(value) || item.tel.includes(value)) {
          this.state.shareUserList.forEach(items => {
            if(items.userId == item.ssoUserId) {
              item.acl = items.acl
              item.userId = items.userId
            }
          })
          searchList.push(item)
        }
      })
      this.setState({ 
        showCompanySearchList: true,
        searchList
      })
    } else { // 搜索框没有值，显示list
      this.setState({ showCompanySearchList: false })
    }
  }
  getSearchType = (info) => {
    let type = ""
    this.state.shareUserList.forEach(item => {
      if(item.userId == info.ssoUserId) {
        if(item.creatorFlag == "1") {
          type = "creator"
        } else {
          type = "join"
        }
      }
    })
    return type
  }
  changeSearchUserCheckbox = (e, info) => {
    if(e.target.checked) { // 添加成员
      this.addCollaboratorUser({
        nickname: info.nickName,
        userId: info.ssoUserId,
        figure: info.figure || ""
      })
    } else { // 删除成员
      this.removeCollaboratorUser(info.ssoUserId)
    }
  }
  getBgIndex = (userId) => {
    const length = this.state.userBgColorList.length
    if(!userId) return length - 1
    const key = userId[userId.length -1]
    var s = 'a b c d e f g h i j k l m n o p q r s t u v w x y z 0 1 2 3 4 5 6 7 8 9';
    var sArray=s.split(' ');
    let keyIndex = 0
    sArray.forEach((item,index) => {
      if(key === item) keyIndex = index%length
    })
    return keyIndex
  }
  getShareCollaborationUserList = (shareUserList) => {
    return (
      <div className="userPopover">
        {
          shareUserList.map((item,index) => {
            const background = this.state.userBgColorList[this.getBgIndex(item.userId)]
            return (
              <li key={index} >
                {!!item.figure &&
                  <img className="userPortrait" src={item.figure} alt=""/>
                }
                {!item.figure &&
                  <p className="defaultPortrait" style={{background}}>{item.nickName[0].toUpperCase()}</p>
                }
              </li>
            )
          })
        }
        <span>{shareUserList.length}位成员</span>
      </div>
    ) 
  }
  getFileName = async () => {
    let fileName = await fileController.getFileName()
    if(fileName.includes("%3D")) {
      fileName = decodeURIComponent(decodeURIComponent(fileName))
      fileName = fileName.split("filename=")[1].split("&")[0]
    }
    this.setState({
      fileName: fileName
    })
    // return pdfDoc.info.fileName
  }
  getUserInfoType = (info) => {
    if(info.aclScope == 1) {
      return '仅下发指定人 可查看/标注'
    } else {
      if(info.acl == 0) {
        return '任何人 可查看'
      } else {
        return '任何人 可标注'
      }
    }
  }

  render() {
    const { realNameDialog, sharePageDialog, createdShareDialog, errText, getKeyText, realNameSuccessDialog, fileName, checkRadioValue, showCompanyUserList, shareUserList, treeData, checkUserList, treeIdList, showResetLinkModel,showCompanySearchList, searchList, shareSearchUserValue, showSpin, showDeleteShareModel } = this.state
    // const { /*shareDisabled,*/ shareDocsInfo } = store.shareStore
    const shareDocsInfo = this.getInfo()
    const { shareUserType } = store.shareCollaborationStore
    const maxCode = 6
    return (
      <div>
        {
          <Button className="share-collaboration-btn c-ok fw-share-collaboration-btn" onClick={this.shareCollaborationClick} disabled={!store.viewer.hasOpenFile}>分享</Button>
        }
        
        {/* <Tooltip placement="bottom" title={"分享"}>
          <i className={`share-btn icon-btn cursor-pointer ${shareDisabled&&"shareDisabled"}`} onClick={this.shareClick} />
        </Tooltip> */}
        { realNameDialog && <Modal
            width={362}
            closable = { true }
            title=""
            visible = { realNameDialog }
            className = "noPdf shareBox"
            bodyClassName
            footer = {[
              <Button key="submit" type="primary" onClick={this.setBindTel}>立即绑定</Button>
            ]}
            onCancel= {() => {this.setState({realNameDialog:false})}}
          >
            <div>
              <img  src={require('../../assets/fw_cloud_editor/main/bindPhone.png')} alt="提示" />
              <p>
                绑定手机，开启登录两步验证，账号更安全。
              </p>
            </div>
            <div className="realNameForm">
              <Input placeholder="请输入手机号码" onChange={(e) => this.changeTel(e)} ></Input>
              <div className="getKeyBox">
                <Input placeholder="请输入验证码" maxLength={maxCode} onChange={(e) => this.changeCode(e)} /><Button key="getKey" onClick={this.getKey}>{ getKeyText }</Button>
              </div>
              <p className="errText">{ errText || "" }</p>
            </div>
          </Modal>
        }
        { 
          realNameSuccessDialog && <Modal
            width={362}
            closable = { true }
            title=""
            visible = { realNameSuccessDialog }
            className = "noPdf bindSuccerBox"
            footer = {null}
            onCancel= {() => {this.setState({realNameSuccessDialog:false})}}
          >
            <div>
              <img  src={require('../../assets/fw_cloud_editor/main/bindSuccess.png')} alt="成功" />
              <p>
                账号绑定成功!
              </p>
            </div>
          </Modal>
        }
        {/* 分享信息页面 */}
        { sharePageDialog && <Modal
            width={600}
            closable = { true }
            title={ "分享" || fileName || "福昕云编辑" }
            visible = { sharePageDialog }
            className = "noPdf shareBox dialogTitle createdShareCollaborationDialog createdShareCollaborationInfoDialog"
            footer = {null}
            onCancel= {() => {this.setState({sharePageDialog:false})}}
          >
            <div className="sharePageDialog shareCollaborationDialog" onClick={(e) => {e.stopPropagation(); this.hideCompanyBtn()}}>
              <div className="sharePageDialogLeft">
                <p>邀请他人加入分享</p>
                <div className="copyBox shareCollaborationInfoBox" onClick={(e) => {e.stopPropagation()}}>
                  <div className='shareCollaborationInfoMain'>
                    <div>
                      {shareUserType == "joinShareUser" && <span>
                          { this.getUserInfoType(shareDocsInfo)}
                        </span>}
                      {shareUserType !== "joinShareUser" && <Select className="arrowSelect" value={shareDocsInfo.shareValueType} showArrow={false} onChange={(e) => {this.changeActiveDay(e, "shareValueType")}} dropdownMatchSelectWidth={false} dropdownClassName="selectOptionDropdown selectOptionDropdownUserType">
                        <Option value={"publicShow"}>任何人 可查看</Option>
                        <Option value={"publicAnnot"}>任何人 可标注</Option>
                        <Option value={"appointorShare"}>仅下发指定人 可查看/标注</Option>
                        <Option value={"resetLink"}>重置链接</Option>
                        <Option value={"deleteShare"}>取消分享</Option>
                      </Select>}
                      {shareUserType !== "joinShareUser" && <Select className="arrowSelect arrowColor666" value={shareDocsInfo.activeDays} showArrow={false} onChange={(e) => {this.changeActiveDay(e, "activeDays")}} dropdownMatchSelectWidth={false} dropdownClassName="selectOptionDropdown">
                        <Option value={7}>7天有效</Option>
                        <Option value={30}>30天有效</Option>
                        <Option value={0}>永久有效</Option>
                      </Select>}
                      {shareUserType !== "joinShareUser" && <Select className="arrowSelect selectWidth120 arrowColor666" value={shareDocsInfo.isEncrypted} showArrow={false} onChange={(e) => {this.changeActiveDay(e, "isEncrypted")}} dropdownMatchSelectWidth={false} dropdownClassName="selectOptionDropdown">
                        <Option value={0}>公开分享</Option>
                        <Option value={1}>加密分享</Option>
                      </Select>}
                    </div>
                    <div className='showPasswordBox'>
                      <p>{shareDocsInfo.shareUrl}</p>
                      {shareUserType !== "joinShareUser" && shareDocsInfo.drawCode && <span className="showPasswordInCopy">密码: {shareDocsInfo.drawCode}</span> }
                    </div>
                  </div>
                  <Button key="copyBtn" onClick={this.copyThis}>复制</Button>
                </div>
                {
                  shareUserType !== "joinShareUser" && <div className='shareUserBox'>
                  <div className='shareUserHead'>
                    {checkUserList && checkUserList.length<1 && <p>已加入分享的人</p>}
                    {checkUserList && checkUserList.length>0 && <div className='checkUserListBox'>
                      <span className='checkUserListNumber'>已选择 ({ checkUserList.length})</span>
                      <Select className="arrowSelect selectWidth120 userArrowSelect" placeholder="批量操作" showArrow={false} onChange={(e) => {this.changeCheckUser(e, checkUserList, shareUserList)}} dropdownMatchSelectWidth={false} dropdownClassName="selectOptionDropdown">
                        <Option value={"0"}>可查看</Option>
                        <Option value={"1"}>可标注</Option>
                      </Select>
                    </div>}
                  </div>
                  <div className='shareUserBody' onClick={(e) => {e.stopPropagation()}}>
                    <Input
                      placeholder="搜索用户名称、手机号，添加协作者"
                      value={shareSearchUserValue}
                      prefix={<PlusOutlined style={{ color: '#895aa4' }} onClick={ () => {
                        this.showCompanyBtn()
                      }} />}
                      suffix={
                        showCompanyUserList ? 
                        <CloseOutlined style={{ color: '#895aa4' }} onClick={() => {
                          this.setState({
                            shareSearchUserValue: "",
                            showCompanySearchList: false,
                            searchList: []
                          })
                          // this.hideCompanyBtn()
                        }}/> : <span />
                      }
                      onChange= {this.shareSearchInput}
                      onFocus = {(e) => {this.showCompanyBtn(); e.stopPropagation(); }}
                      // onClick= {() => {e.stopPropagation()}}
                    />
                    {
                      !showCompanyUserList && 
                      <Checkbox.Group onChange={this.onCheckboxChange}>
                        <div className='shareUserList'>
                          {
                            shareUserList && shareUserList.map(item => {
                              return (
                                <div key={item.id} className='shareUserItem'>
                                  {shareUserList.length>1 && <Checkbox value={item.userId} disabled={item.creatorFlag==1}></Checkbox>}
                                  { item.figure && <img src={figure} alt={"头像"} /> }
                                  {!item.figure && <img src={require('../../assets/fw_cloud_editor/header/user.png')} alt={"头像"} />}
                                  <div className='shareUserInfo'>
                                    <h5>{item.nickName}</h5>
                                    <p>{item.joinDesc}</p>
                                  </div>
                                  {item.creatorFlag!=1 && <div>
                                    <Select className="arrowSelect arrowSelect100 userArrowSelect arrowColor666" value={item.acl} showArrow={false} onChange={(e) => {this.changeUser(e, item)}} dropdownMatchSelectWidth={false} dropdownClassName="selectOptionDropdown">
                                      <Option value={"0"}>可查看</Option>
                                      <Option value={"1"}>可标注</Option>
                                      <Option value={"delete"}>删除</Option>
                                    </Select>
                                  </div>}
                                </div>
                              )
                            })
                          }
                        </div>
                      </Checkbox.Group>
                    }
                    {
                      showCompanyUserList && !showCompanySearchList && <div className='companyUserList'>
                        <img src={require('../../assets/fw_cloud_editor/icon_company.png')} alt={"公司"} />
                        <div>
                          <Tree
                            treeData={treeData}
                            checkable = {true}
                            onCheck={this.onCheck}
                            defaultExpandParent={true}
                            defaultCheckedKeys = { treeIdList }
                            defaultExpandAll = {true}
                            expandAction = {'click'}
                          />
                        </div>
                      </div>
                    }
                    {
                      showCompanyUserList && showCompanySearchList && searchList.length<1 && <div className='companyUserSearchList'>
                        <img src={require('../../assets/fw_cloud_editor/searchNull.png')} alt={"搜索空"} />
                        <h5>找不到对应的用户</h5>
                        <p>你可以直接复制链接发送</p>
                      </div>
                    }
                    {
                      showCompanyUserList && showCompanySearchList && searchList.length>0 && <div className='companyUserSearchList'>
                        <ul>
                          {
                            searchList.map((item, index) => {
                              let type = this.getSearchType(item, index)
                              return (
                                <li key={item.id} className='shareUserItem'>
                                  <Checkbox checked={!!type} value={item.ssoUserId} disabled={type==="creator"} onChange={(e) => {this.changeSearchUserCheckbox(e, item)}}></Checkbox>
                                  { item.figure && <img src={figure} alt={"头像"} /> }
                                  {!item.figure && <img src={require('../../assets/fw_cloud_editor/header/user.png')} alt={"头像"} />}
                                  <div className='shareUserInfo'>
                                    <h5>{item.nickName}</h5>
                                    <p>{item.joinDesc}</p>
                                  </div>
                                  {type==='join' && <div>
                                    <Select className="arrowSelect arrowSelect100 userArrowSelect arrowColor666" value={item.acl} showArrow={false} onChange={(e) => {this.changeUser(e, item)}} dropdownMatchSelectWidth={false} dropdownClassName="selectOptionDropdown">
                                      <Option value={"0"}>可查看</Option>
                                      <Option value={"1"}>可标注</Option>
                                    </Select>
                                  </div>}
                                </li>
                              )
                            })
                          }
                        </ul>
                      </div>
                    }
                  </div>
                </div>
                }
              </div>
            </div>
          </Modal>
        }
        {/* 创建分享页 */}
        { 
          createdShareDialog && <Modal
            width={450}
            destroyOnClose = { true }
            closable = { true }
            title={ fileName || "分享" }
            visible = { createdShareDialog }
            className = "noPdf createdShareDialog dialogTitle createdShareCollaborationDialog"
            footer={[
              <Button key="submitCreated" type="primary" onClick={this.createLink}>创建并分享</Button>,
              <Button key="submit" onClick={() => {this.setState({createdShareDialog:false})}}>取消</Button>
            ]}
            onCancel= {() => {this.setState({createdShareDialog:false})}}
          >
            <Spin tip="创建中..." spinning={showSpin}>
              <div>
                <p>公开分享</p>
                <ul>
                  <li className={`shareLi ${checkRadioValue==="publicShow"&&"active"}`} onClick={() => {this.checkRadio("publicShow")}} >
                    <img src={require("../../assets/fw_cloud_editor/main/overt.png")}></img>
                    <div>
                      <p>任何人可查看</p>
                      <p>适用于文件公开分享</p>
                    </div>
                    <input className="shareRadio" type="radio" name="type" value="publicShow" checked={checkRadioValue==="publicShow"} onChange={() => {}}/>
                  </li>
                  <li className={`shareLi ${checkRadioValue==="publicAnnot"&&"active"}`}  onClick={() => {this.checkRadio("publicAnnot")}} >
                    <img src={require("../../assets/fw_cloud_editor/main/encryption.png")} alt="加密分享"></img>
                    <div>
                      <p>任何人可标注</p>
                      <p>适用于文件公开分享，允许他人标注</p>
                    </div>
                    <input className="shareRadio" type="radio" name="type" value="publicAnnot" checked={checkRadioValue==="publicAnnot"} onChange={() => {}}/>
                  </li>
                </ul>
              </div>
              <div>
                <p>指定范围分享</p>
                <ul>
                  <li className={`shareLi ${checkRadioValue==="appointorShare"&&"active"}`} onClick={() => {this.checkRadio("appointorShare")}} >
                    <img src={require("../../assets/fw_cloud_editor/main/overt.png")}></img>
                    <div>
                      <p>仅指定人可查看/标注</p>
                      <p>适用于隐私文件，可指定查看/标注</p>
                    </div>
                    <input className="shareRadio" type="radio" name="type" value="appointorShare" checked={checkRadioValue==="appointorShare"} onChange={() => {}}/>
                  </li>
                </ul>
              </div>
            </Spin>
          </Modal>
        }
        {
          <Modal
            visible={showResetLinkModel}
            title="云编辑"
            onOk={this.resetShareUrlFunc}
            onCancel={() => {this.setState({showResetLinkModel:false})}}
            okText="确认"
            cancelText="取消"
          >
            <ExclamationCircleOutlined style={{ color: "#f6545a", fontSize: "28px", verticalAlign: "middle", marginRight: "10px"}} />
            <span>重置链接旧的链接将会失效，您确认重置？</span>
          </Modal>
        }
        {
          <Modal
            visible={showDeleteShareModel}
            title="取消分享"
            // onOk={this.deleteShareUrlFunc}
            onCancel={() => {this.setState({showDeleteShareModel:false})}}
            // okText="确认"
            // cancelText="取消"
            className = "deleteShareDialog"
            footer = {[
              <Button key="submit" type="primary" onClick={this.deleteShareUrlFunc}>确定</Button>,
              <Button key="submitCancel" onClick={() => {this.setState({showDeleteShareModel:false})}}>取消</Button>
            ]}
          >
            <p>请确认取消分享  <span>【{fileName}】</span></p>
            <p>取消后，所有成员将无法继续访问</p>
            <div>
              {this.getShareCollaborationUserList(shareUserList)}
            </div>
          </Modal>
        }
      </div>
    )
  }
}
export default shareCollaborationbtn;
